const DOCLINKS = {
	TRACES_EXPLORER_EMPTY_STATE:
		'https://signoz.io/docs/instrumentation/overview/?utm_source=product&utm_medium=traces-explorer-empty-state',
	USER_GUIDE: 'https://signoz.io/docs/introduction/',
	TRACES_DETAILS_LINK:
		'https://signoz.io/docs/userguide/traces/?utm_source=product&utm_medium=traces-explorer-trace-tab#traces-view',
	METRICS_EXPLORER_EMPTY_STATE:
		'https://signoz.io/docs/metrics-management/send-metrics/',
	EXTERNAL_API_MONITORING:
		'https://signoz.io/docs/external-api-monitoring/overview/',
	QUERY_CLICKHOUSE_TRACES:
		'https://signoz.io/docs/userguide/writing-clickhouse-traces-query/#timestamp-bucketing',
	QUERY_CLICKHOUSE_LOGS:
		'https://signoz.io/docs/userguide/logs_clickhouse_queries/',
	QUERY_CLICKHOUSE_METRICS:
		'https://signoz.io/docs/userguide/write-a-metrics-clickhouse-query/',
	AGENT_SKILL_INSTALL:
		'https://signoz.io/docs/ai/agent-skills/#install-the-plugin',
};

export default DOCLINKS;
